// [FW-4033] Batas keterlambatan injeksi pixel. Sesuai AC: PageView/ViewContent boleh
// terkirim paling lambat 2 detik lebih lambat dari sebelumnya.
const MAX_DELAY_MS = 2000;

/**
 * Menjalankan `callback` setelah halaman selesai render atau saat browser idle, dengan batas
 * keras `timeout` ms supaya event tracking tidak pernah tertunda lebih lama dari itu.
 *
 * Dipakai untuk menunda injeksi script pixel seller (GTM, FB, Google Ads, TikTok): script-nya
 * tidak lagi ikut memakan main thread saat buyer masih menunggu form bisa dipakai.
 *
 * @returns {{flush: Function, cancel: Function}} `flush` langsung menjalankan callback kalau
 *   belum jalan (buyer submit sebelum pixel dimuat), `cancel` membatalkannya.
 */
export function runWhenPageIdle(callback, { timeout = MAX_DELAY_MS } = {}) {
  if (typeof window === 'undefined') {
    callback();
    return { flush() {}, cancel() {} };
  }

  let isSettled = false;
  let capId = null;
  let idleId = null;

  const clearSchedule = () => {
    window.clearTimeout(capId);
    window.removeEventListener('load', scheduleIdle);
    if (idleId !== null && typeof window.cancelIdleCallback === 'function') {
      window.cancelIdleCallback(idleId);
    }
  };

  const run = () => {
    if (isSettled) return;
    isSettled = true;
    clearSchedule();
    callback();
  };

  function scheduleIdle() {
    if (typeof window.requestIdleCallback === 'function') {
      idleId = window.requestIdleCallback(run, { timeout });
    } else {
      window.setTimeout(run, 0);
    }
  }

  // Batas keras: apa pun yang terjadi dengan event load atau idle, pixel tetap jalan.
  capId = window.setTimeout(run, timeout);

  if (document.readyState === 'complete') {
    scheduleIdle();
  } else {
    window.addEventListener('load', scheduleIdle, { once: true });
  }

  return {
    flush: run,
    cancel() {
      isSettled = true;
      clearSchedule();
    }
  };
}
